import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { brandColors } from '../../theme';

export const FooterCTA: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        py: { xs: 6, md: 8 },
        backgroundColor: brandColors.lightGray,
        borderTop: `1px solid ${brandColors.lightGray}`,
      }}
    >
      <Container maxWidth="md">
        <Box sx={{ textAlign: 'center' }}>
          <Typography
            variant="h4"
            sx={{
              color: brandColors.indigo,
              fontWeight: 600,
              mb: 4,
              fontSize: { xs: '1.75rem', sm: '2rem', md: '2.5rem' },
            }}
          >
            Start Your MarketCompass Journey Today
          </Typography>

          <Button
            variant="contained"
            size="large"
            endIcon={<ArrowForward />}
            onClick={() => navigate('/global-market-reports')}
            sx={{
              backgroundColor: brandColors.gold,
              color: brandColors.white,
              px: 5,
              py: 1.75,
              fontSize: '1.125rem',
              fontWeight: 600,
              borderRadius: 2,
              textTransform: 'none',
              boxShadow: '0 4px 12px rgba(245, 168, 0, 0.3)',
              '&:hover': {
                backgroundColor: '#E09600',
                transform: 'translateY(-2px)',
                boxShadow: '0 6px 16px rgba(245, 168, 0, 0.4)',
              },
              transition: 'all 0.3s ease',
            }}
          >
            Explore Markets
          </Button>
        </Box>
      </Container>
    </Box>
  );
};